"use client";

import { createT } from "@/app/[lang]/_utils/create-t";
import type { Lang } from "@/langs";
import { api } from "@/trpc/react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
} from "@borderless/ui/components/dialog";
import { usePathname } from "next/navigation";
import { useContext } from "react";
import { AuthForm } from "../AuthForm";
import { AuthModalContext } from "../AuthModalProvider";
import dictionary from "./t.json";

const t = createT(dictionary);

type AuthModalProps = {
  lang: Lang;
};

export function AuthModal(props: AuthModalProps) {
  const { data: user, isLoading } = api.user.findSelf.useQuery();
  const { data: isInsecureInAppBrowser } =
    api.user.isBrowserInsecure.useQuery();

  const pathname = usePathname();

  const [isModalOpen, setIsModalOpen] = useContext(AuthModalContext);

  if (isLoading) return null;
  if (user) return null;

  return (
    <Dialog open={isModalOpen} onOpenChange={setIsModalOpen}>
      <DialogContent className="border-none bg-background data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=closed]:slide-out-to-bottom-[48%] data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95 data-[state=open]:slide-in-from-bottom-[48%]">
        <DialogTitle className="hidden">Sign up to Borderless</DialogTitle>
        <div className="mx-auto">
          <AuthForm
            isInsecureInAppBrowser={isInsecureInAppBrowser ?? false}
            lang={props.lang}
            type="signup"
            pageType="modal"
            signupText={getSignupText(pathname, props.lang)}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}

const getSignupText = (pathname: string, lang: Lang) => {
  if (pathname.endsWith("/stories") || pathname.endsWith("/guidebook"))
    return t("Create a FREE account to continue reading", lang);
  return undefined;
};
